import { css } from '@emotion/react';
import { darkGray } from 'athena/styles/colors';
import Truncate from 'react-truncate';
import { CellProps } from './types';
import { commonStyles } from './styles';
import Avatar from '../../avatar';

const NameCell = (props: CellProps) => {
  const { cell, className } = props;

  const value = cell.getValue();
  const { row: { original: { role } } } = cell;

  const styles = css`
    ${commonStyles};

    .picture {
      flex-shrink: 0;
    }

    .right-container {
      flex: 1;
    }

    .email {
      color: ${darkGray};
    }
  `;

  return (
    <div className={`d-flex align-items-center ${className}`} css={styles}>
      <Avatar user={value} role={role?.name} className='picture mr-2' />
      <div className='right-container d-flex flex-column justify-content-center align-items-stretch'>
        <div className='truncated-container'>
          <Truncate
            lines={1}
            ellipsis='...'
            className='text-medium bold'
          >
            {value.firstName} {value.lastName}
          </Truncate>
        </div>
        <div>
          <Truncate
            className='text-small email'
            lines={3}
            ellipsis='...'
          >
            {value.email}
          </Truncate>
        </div>
      </div>
    </div>
  );
};

export default NameCell;
